'use strict';

import angular from 'angular';

import restButtonDirective from '../rest-button';
import modalDirective from '../rest-modal';

import deleteTemplate from './delete.html';

const MODULE_NAME = 'daupler.incidents.components.buttons.manage';

var app = angular.module(MODULE_NAME, [
]);

function getManageUrl($incident) {
	return `/api/manage/incident/${$incident.uuid}/`;
}

app.directive('archiveIncident', restButtonDirective({
	getUrl: getManageUrl,
	method: 'PATCH',
	data: {archived: true},
	successMessage: 'The incident has been archived.',
}));

app.directive('unarchiveIncident', restButtonDirective({
	getUrl: getManageUrl,
	method: 'PATCH',
	data: {archived: false},
	successMessage: 'The incident has been removed from the archive.',
}));

app.directive('completeIncident', restButtonDirective({
	getUrl: getManageUrl,
	method: 'PATCH',
	data: {completed: true},
	successMessage: 'The incident has been marked as completed.',
}));

app.directive('incompleteIncident', restButtonDirective({
	getUrl: getManageUrl,
	method: 'PATCH',
	data: {completed: false},
	successMessage: 'The incident has been marked as incomplete.',
}));

app.directive('deleteIncident', modalDirective({
	template: deleteTemplate,
}));

export default MODULE_NAME;
